module.exports = __webpack_public_path__ + "static/img/fix4.d4fc18a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/fix4.jpg
// module id = 1mqp
// module chunks = 1